<template>
	<div class="container">
		<el-button type="primary" @click="getToken">获取token</el-button>
		<el-card class="box-card w-50" v-if="host && token">
			<div class="title">Host:</div>
			<div class="content">{{ host }}</div>
			<div class="title">
				Token:
			</div>
			<div class="content">{{ token }}</div>
		</el-card>
		<el-card class="box-card w-50">
			<el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="Host">
					<el-input v-model="ruleForm.host" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="Token">
					<el-input v-model="ruleForm.token" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">更新token</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>
<script>
export default {
	name: 'DomainList',

	data() {
		return {
			token: '',
			host: '',
			ruleForm: {
				host: '',
				token: ''
			}
		};
	},
	created() {
		this.getToken();
	},

	computed: {},

	methods: {
		paste() {
			this.ruleForm.host = this.host;
			this.ruleForm.token = this.token;
		},
		getToken() {
			// http://slink8.xyz/admin/token/get
			// /token/admin/token/get
			// 获取域名
			const domain = window.location.protocol + '//' + window.location.host + '/admin/token/get'
			fetch(domain, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json' // 根据实际情况设置请求头
				}
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((res) => {
					console.log('获取的token', res);
					this.token = res.data.data.Token;
					this.host = res.data.data.Host;
					this.paste();
				})
				.catch((error) => {
					console.error('请求失败', error);
				});
		},
		setToken() {
			// 创建一个 FormData 对象
			const formData = new FormData();
			const domain = window.location.protocol + '//' + window.location.host + '/admin/token/set'
			// 添加键值对到 FormData 对象
			formData.append('token', this.ruleForm.token);
			formData.append('host', this.ruleForm.host);
			// http://slink8.xyz/admin/token/set
			// /token/admin/token/set
			fetch(domain, {
				method: 'POST',
				body: formData
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((data) => {
					console.log('设置token成功', data);
					this.tipMsg();
					this.ruleForm.host = '';
					this.ruleForm.token = '';
					this.getToken();
				})
				.catch((error) => {
					console.error('设置token失败', error);
				});
		},
		submitForm() {
			this.setToken();
		},
		// 提示
		tipMsg() {
			setTimeout(() => {
				this.$baseNotify(this.langTxt('更新成功'), 'success', 'success'); // message, title, type
			}, 200);
		}
	}
};
</script>
<style>
.w-50 {
	width: 50%;
}

.box-card {
	margin-top: 20px;
}

.title {
	font-size: 20px;
	font-weight: 500;
}

.content {
	font-size: 18px;
}

.flex {
	display: flex;
	justify-content: space-between;
}
</style>
